module.exports = __webpack_public_path__ + "img/tool-qa.180398b.webp";